export const counter = () => {

  const counter = document.querySelector(".events__counter");
  const counterValue = document.querySelector(".events__counter span");
  const counterDate = counter?.dataset.date.split(".");
  const counterTime = counter?.dataset.time.split(":");
  const counterWidth = document.querySelector(".events__counter span")?.offsetWidth;

  if ( counterDate ) {
    var matchDate = new Date( counterDate[2], (+counterDate[1] - 1), counterDate[0], counterTime[0], counterTime[1] );
    var todayDate = new Date();

    if ( todayDate < matchDate ) {
      setInterval(() => {
      
        todayDate = +todayDate + 1000;
        
        //var matchDate = new Date( 2024, 1, 29, 15 );
    
        //console.log( todayDate );
        //console.log( matchDate );
    
        var between = matchDate - todayDate
        //console.log( between );
    
        var days = Math.floor(between / 86400000);
        if ( days < 10 ) {
          days = "0" + days;
        }
        //console.log( days );
    
        var hours = Math.floor((between - (days * 86400000)) / 1000 / 60 / 60) ;
        if ( hours < 10 ) {
          hours = "0" + hours;
        }
        //console.log( hours );
    
        var minutes = Math.floor((between - (days * 86400000) - (hours * 1000 * 60 * 60)) / 1000 / 60) ;
        if ( minutes < 10 ) {
          minutes = "0" + minutes;
        }
        //console.log( minutes );
    
        var seconds = Math.floor((between - (days * 86400000) - (hours * 1000 * 60 * 60) - (minutes * 1000 * 60)) / 1000) ;
        if ( seconds < 10 ) {
          seconds = "0" + seconds;
        }
        //console.log( seconds );
    
        counterValue.innerHTML = 
        days + " : " +
        hours + " : " +
        minutes + " : " +
        seconds;
      }, 1000);
    }
  }
 

  //console.log( counterWidth );

  


}